import { render, staticRenderFns } from "./create_group.vue?vue&type=template&id=2c3eced0&"
import script from "./create_group.vue?vue&type=script&lang=js&"
export * from "./create_group.vue?vue&type=script&lang=js&"
import style0 from "./create_group.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports